module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "showClose": false,
      "isBgOverlay": true,
      "isCloseOnEsc": !_vm.activeOpusUser
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal__full-width",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.userName) + " "), _c('span', {
    staticClass: "d-tag marg-1-left"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__header__right"
  }, [(_vm.canBulkSendUserDays) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit no-print",
    class: {
      'do-bttn--submit--loading': _vm.isBulkSending,
      'do-bttn--submit--disabled': _vm.isBulkSending
    },
    attrs: {
      "disabled": _vm.isBulkSending
    },
    on: {
      "click": function($event) {
        return _vm.$emit('bulkSendUserDays', _vm.user.days)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.bulkSendButtonLabel) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isOpusIntegrationActive) ? _c('button', {
    staticClass: "do-bttn no-print",
    on: {
      "click": function($event) {
        return _vm.setActiveOpusUser(_vm.user)
      }
    }
  }, [_vm._v("\n          Se i OPUS\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "do-bttn no-print",
    on: {
      "click": function($event) {
        _vm.isShowUserTable = !_vm.isShowUserTable
      }
    }
  }, [_vm._v("\n          Vis tabel\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn no-print",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle no-print",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content",
    attrs: {
      "id": "printUserSalary"
    }
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('h4', {
    staticClass: "italic"
  }, [_vm._v("\n        Ikke flere dage på brugeren i "), _c('span', {
    staticClass: "d-tag"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.isLoading) ? _c('div', {
    staticClass: "user-list__user"
  }, [_c('h2', {
    staticClass: "only-print marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.user && _vm.user.v_user_name ? _vm.user.v_user_name : '') + " "), _c('span', {
    staticClass: "d-tag marg-1-left"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "user-list__user__header"
  }, [_c('h4', [_vm._v("Samlet timer for perioden i "), _c('span', {
    staticClass: "d-tag"
  }, [_vm._v(_vm._s(_vm.title))]), _c('br'), _vm._v(_vm._s(_vm.titleOfPeriod))]), _vm._v(" "), _c('ul', _vm._l((_vm.user.v_user_sums), function(sum) {
    return _c('li', {
      key: sum.vId,
      class: {
        'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
      }
    }, [_vm._v("\n              " + _vm._s(sum.employment_title) + " " + _vm._s(sum.costCenter ? '[' + sum.costCenter + '] ' : '') + "\n              "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))])])
  }), 0)]), _vm._v(" "), (_vm.isShowUserTable) ? _c('SalarySubsPerfUserTable', {
    attrs: {
      "user": _vm.user,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "close": function($event) {
        _vm.isShowUserTable = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "user-list__user__table user-list__user__table--active"
  }, [_vm._l((_vm.user.days), function(userDay) {
    return [_c('tr', {
      staticClass: "user-list__user__table__header"
    }, [_c('th', [_vm._v(_vm._s(userDay.v_date_formatted))]), _vm._v(" "), _c('th', [_vm._v("Kalender")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Vikar for")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Lønkode")]) : _vm._e(), _vm._v(" "), (_vm.costCenters.length > 0) ? _c('th', [_vm._v("Omkostningssted")]) : _vm._e(), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
      staticClass: "no-print"
    })]), _vm._v(" "), _c('SalarySubsPerfUserDay', {
      attrs: {
        "user": _vm.user,
        "userDay": userDay,
        "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
        "salaryCodes": _vm.salaryCodes,
        "costCenters": _vm.costCenters
      },
      on: {
        "updatePropOnLesson": function($event) {
          return _vm.$emit('updatePropOnLesson', $event)
        }
      }
    }), _vm._v(" "), _c('tr', {
      key: 'foot-' + userDay.day,
      staticClass: "user-list__user__table__footer"
    }, [_c('td', {
      attrs: {
        "colspan": _vm.isSalaryIntegrationActive ? 10 : _vm.costCenters.length > 0 ? 9 : 8
      }
    }, [_c('div', {
      staticClass: "user-list__user__footer"
    }, [_c('ul', {
      staticClass: "user-list__user__footer__sums"
    }, _vm._l((userDay.v_sums), function(sum) {
      return _c('li', {
        key: sum.vId,
        class: {
          'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
        }
      }, [_vm._v("\n                      " + _vm._s(sum.employment_title) + " " + _vm._s(sum.costCenter ? '[' + sum.costCenter + '] ' : '') + "\n                      "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))])])
    }), 0), _vm._v(" "), (userDay.state === 'draft') ? [(_vm.getIsDayValidated(userDay)) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n                      arrow: true,\n                      animateFill: false,\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                    }"
      }],
      staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled no-print",
      attrs: {
        "content": _vm.validationTxt
      }
    }, [_vm._v("\n                      Godkend\n                    ")]) : _c('button', {
      staticClass: "do-bttn do-bttn--submit no-print",
      class: {
        'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
      },
      on: {
        "click": function($event) {
          return _vm.$emit('approveDay', userDay)
        }
      }
    }, [_vm._v("\n                      Godkend\n                    ")])] : _vm._e(), _vm._v(" "), (userDay.state === 'approved') ? _c('div', {
      staticClass: "submit-buttons no-print"
    }, [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n                      arrow: true,\n                      animateFill: false,\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                    }"
      }],
      staticClass: "do-bttn do-bttn--danger no-print",
      class: {
        'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
      },
      attrs: {
        "content": 'Dagen vil blive genberegnet'
      },
      on: {
        "click": function($event) {
          return _vm.$emit('unApproveDay', userDay)
        }
      }
    }, [_vm._v("\n                      Fortryd godkendelse\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "do-bttn do-bttn--submit no-print",
      class: {
        'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
      },
      on: {
        "click": function($event) {
          return _vm.$emit('changeStateIsSent', userDay)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.isSalaryIntegrationActive ? 'Send til lønsystem' : 'Er indberettet') + "\n                    ")])]) : _vm._e(), _vm._v(" "), (userDay.approved_at) ? _c('span', {
      staticClass: "do-approved-by"
    }, [_vm._v("\n                    " + _vm._s(userDay.v_approved) + "\n                  ")]) : _vm._e()], 2)])])]
  })], 2)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.activeOpusUser) ? _c('SalarySubsPerfUserOpusModal', {
    attrs: {
      "user": _vm.activeOpusUser,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "schoolId": _vm.schoolId
    },
    on: {
      "close": function($event) {
        return _vm.setActiveOpusUser(null)
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fe44b62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySubsPerfUser.vue
// module id = 1876
// module chunks = 1